module.exports = __webpack_public_path__ + "img/CG community news banner.ca2eaeb4.png";